import React from "react";
import api from "utils/api";
import { connect } from "react-redux";
import {
  Button,
  Form,
  Input,
  message, Row, Col, Card
} from "antd";
import "./CaseNotes.scss"
const { TextArea } = Input;
import { ArrowRightOutlined } from "@ant-design/icons";
import SubmitButton from '../Patient/SubmitButton'
import { CONSTANTS } from "utils/constant";
const requiredMessage = "This field is required!";
 class DoctorDescription extends React.Component {
  formDescription = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      update_button: false,
      disable_button:true,
      buttonLoading: true
    };
  }

  componentDidMount() {
    this.props.formAction(false)
    this.getDoctorDescription()
  }

  getDoctorDescription() {
    this.setState({buttonLoading: false})
    api
      .get_consultation_details({
        app_id: this.props.appointment_id,
        type: "doctor_description",
      })
      .then((response) => {
        let data =
          response.data?.data?.results?.doctor_description[
            response.data?.data?.results?.doctor_description.length - 1
          ];
          if(data?.length>0){
            this.setState({disable_button:false, buttonLoading: false})
          }
        if (data && response.data?.status == 200) {
          this.setState({ update_button: true, buttonLoading: false });
          this.formDescription.current?.setFieldsValue({ description: data });
        }
      })
      .catch((err) => {});
  }

  handleSubmit = (val) => {
    (val["ticket_type"] = "care_team_assignment"),
      (val["appointment_id"] = this.props?.appointment_id);
    val["patient_id"] = this.props.patient_id;
    api
      .add_doctor_instruction(val)
      .then((res) => {
        if (res.data?.status == 200) {
          this.setState({ update_button: true ,disable_button:false});
          message.success(res.data?.message , ErrorDuration)
          this.setState({buttonLoading: false})
          this.props.formAction(false)
        } else {
          message.error(`${CONSTANTS.FAILED_TO_ADD_DESCRIPTION}` , ErrorDuration);
          this.setState({buttonLoading: false})
        }
      })
      .catch((err) => {});
  };

  render() {
    return (
      <div className="doctor-description-wrapper" >
        <h4 style={{ fontSize: "16px",}}>{CONSTANTS.INSTRUCTION_GIVEN_BELOW}</h4>
            <Form ref={this.formDescription}
              onFieldsChange={() => { this.props.formAction(true) }}
            //  onValuesChange= {()=>this.props.tabsWithChanges("add","5")}
              onFinish={this.handleSubmit.bind(this)}>
        <Row gutter={24}>
          <Col span={12}>
              <Form.Item
                name="description"
                label={CONSTANTS.INSTRUCTIONS}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 15 }}
                onChange={(e)=>
                 { if(e.target?.value.trim().length>0){
                  this.setState({disable_button:false})}
                  else 
                    e.target?.value?.trim().length==0?
                    this.setState({disable_button:true}):
    null
                }}
                
                labelAlign="left"
                rules={[
                  {
                    required: true,
                    message: requiredMessage,
                  },
                ]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
          </Row>
              <div className="submit-button-wrapper">
                <SubmitButton onClick={e=>{this.setState({buttonLoading: true})}} htmlType={'submit'} type={"button"} label={!this.state.update_button ? `${CONSTANTS.SUBMIT}` : `${CONSTANTS.UPDATE}`} disabled={!this.state.update_button? this.state.disable_button:false} className={this.state.disable_button? " disable-btn":"submit-btn"} loading={this.state.buttonLoading}/>
              {/* <Button disabled={!this.state.update_button? this.state.disable_button:false} className={this.state.disable_button? " disable-btn":"submit-btn"} style={{float:"right"}}
              type="button" htmlType='submit'>{!this.state.update_button ? `${CONSTANTS.SUBMIT}` : `${CONSTANTS.UPDATE}`}<ArrowRightOutlined /></Button> */}
              </div>
         
            </Form>
      </div>

    )
  }
}

export default connect(null)(DoctorDescription);
